import { ApiInstance } from '../instance';

export const ConfigController = {
  getPricingConfig: async () => {
    return await ApiInstance.get('/config/pricing');
  },
};
